"use client";

import { ScrollStages } from "../components/ScrollStages";

export default function Home() {
  return (
    <div className="relative">
      <ScrollStages />
    </div>
  );
}
